import type { AuthView } from "~/features/auth/AuthOverlay";
import { CLOSE_AUTH_OVERLAY, OPEN_AUTH_OVERLAY, type OpenAuthOverlayPayload } from "./AuthReducer";

export const openAuthOverlay = (view: AuthView = "register", options: Omit<OpenAuthOverlayPayload, "view"> = {}) => ({
  type: OPEN_AUTH_OVERLAY,
  payload: { view, ...options },
});

export const closeAuthOverlay = () => ({
  type: CLOSE_AUTH_OVERLAY,
});
